export default "__VITE_ASSET__Du3YO6kh__"